"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RGBColor = exports.DEFAULT_COLORS = void 0;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class RGBColor {
  static isAutoColor(color) {
    return Object.values(color.toObject()).some(prop => prop < 0 || prop > 255);
  }
  static fromObject(obj) {
    return obj instanceof RGBColor ? obj : new RGBColor(obj.r, obj.g, obj.b, obj.a);
  }
  static fromStyleClass(styleClass) {
    const matchGroup = styleClass.match(/^color-(.*)/)[1];
    return new RGBColor(...matchGroup.split('-'));
  }
  static fromCSS(str) {
    const RGBA = str.match(/^rgba?\((.*)\)/)[1];
    return new RGBColor(...RGBA.split(','));
  }
  static guess(color) {
    const parsers = [RGBColor.fromObject, RGBColor.fromHEX, RGBColor.fromCSS, RGBColor.fromStyleClass, RGBColor.fromCMYK];
    let result;
    for (let parser of parsers) {
      try {
        result = parser(color);
        if (result instanceof RGBColor) {
          return result;
        }
      } catch (_unused) {
        continue;
      }
    }
  }
  constructor(_r, _g, _b, _a = 1) {
    _defineProperty(this, "toObject", () => {
      return {
        r: this.r,
        g: this.g,
        b: this.b,
        a: this.a
      };
    });
    _defineProperty(this, "compare", input => {
      const other = RGBColor.guess(input);
      return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    });
    _defineProperty(this, "toCSS", () => {
      return `rgba(${this.r}, ${this.g}, ${this.b}, ${this.a})`;
    });
    _defineProperty(this, "toDraftJsCustomStyle", () => ({
      color: this.toCSS()
    }));
    _defineProperty(this, "toStyleClass", () => `color-${this.r}-${this.g}-${this.b}-${this.a}`);
    _defineProperty(this, "toHEX", () => {
      const {
        r,
        g,
        b
      } = this;
      return `#${(256 + r).toString(16).substr(1)}${(256 + g).toString(16).substr(1)}${(256 + b).toString(16).substr(1)}`;
    });
    _defineProperty(this, "toCMYK", (normalized = true) => {
      const {
        r,
        g,
        b,
        a
      } = this;
      let c = 1 - r / 255;
      let m = 1 - g / 255;
      let y = 1 - b / 255;
      let k = Math.min(c, Math.min(m, y));
      c = (c - k) / (1 - k);
      m = (m - k) / (1 - k);
      y = (y - k) / (1 - k);
      if (!normalized) {
        c = Math.round(c * 10000) / 100;
        m = Math.round(m * 10000) / 100;
        y = Math.round(y * 10000) / 100;
        k = Math.round(k * 10000) / 100;
      }
      c = isNaN(c) ? 0 : c;
      m = isNaN(m) ? 0 : m;
      y = isNaN(y) ? 0 : y;
      k = isNaN(k) ? 0 : k;
      return {
        c,
        m,
        y,
        k,
        a
      };
    });
    [_r, _g, _b, _a].forEach(n => {
      if (Number.isNaN(Number(n))) {
        throw Error('Invalid input');
      }
    });
    this.r = Number(_r);
    this.g = Number(_g);
    this.b = Number(_b);
    this.a = Number(_a);
  }
  // HEX
  static fromHEX(hex) {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, (m, r, g, b) => {
      return r + r + g + g + b + b;
    });
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? RGBColor.fromObject({
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    }) : null;
  }
}
exports.RGBColor = RGBColor;
// CMYK
_defineProperty(RGBColor, "normalizeCMYK", cmyk => {
  const {
    c,
    m,
    y,
    k
  } = cmyk;
  return {
    c: c / 100,
    m: m / 100,
    y: y / 100,
    k: k / 100
  };
});
_defineProperty(RGBColor, "fromCMYK", (cmyk, normalized = true) => {
  if (!normalized) {
    return RGBColor.fromCMYK(RGBColor.normalizeCMYK(cmyk), true);
  }
  const {
    c,
    m,
    y,
    k,
    a = 1
  } = cmyk;
  let R = c * (1.0 - k) + k;
  let G = m * (1.0 - k) + k;
  let B = y * (1.0 - k) + k;
  R = Math.round((1.0 - R) * 255.0);
  G = Math.round((1.0 - G) * 255.0);
  B = Math.round((1.0 - B) * 255.0);
  return new RGBColor(R, G, B, a);
});
RGBColor.black = new RGBColor(0, 0, 0);
RGBColor.white = new RGBColor(255, 255, 255);
RGBColor.cyan = new RGBColor(0, 188, 180);
RGBColor.DEFAULT_COLOR = RGBColor.cyan;
RGBColor.AUTO_COLOR = new RGBColor(-1, -1, -1, -1);
const DEFAULT_COLORS = ['rgb(247, 109, 130)', 'rgb(252, 131, 112)', 'rgb(252, 210, 119)', 'rgb(180, 224, 128)', 'rgb(98, 221, 189)', 'rgb(116, 210, 240)', 'rgb(127, 171, 243)', 'rgb(183, 159, 237)', 'rgb(239, 150, 206)', 'rgb(241, 209, 182)', 'rgb(244, 246, 248)', 'rgb(170, 175, 187)', 'rgb(230, 85, 102)',
// New row
'rgb(244, 110, 85)', 'rgb(247, 209, 91)', 'rgb(155, 214, 107)', 'rgb(80, 207, 171)', 'rgb(97, 189, 231)', 'rgb(109, 150, 233)', 'rgb(177, 139, 233)', 'rgb(233, 131, 190)', 'rgb(236, 201, 165)', 'rgb(228, 232, 235)', 'rgb(100, 107, 119)', 'rgb(212, 69, 85)',
// New row
'rgb(227, 87, 67)', 'rgb(239, 189, 74)', 'rgb(134, 196, 84)', 'rgb(64, 187, 155)', 'rgb(79, 170, 216)', 'rgb(91, 129, 217)', 'rgb(154, 113, 217)', 'rgb(211, 107, 172)', 'rgb(223, 184, 147)', 'rgb(203, 208, 215)', 'rgb(67, 71, 82)', 'rgb(0, 0, 0)', 'rgb(255, 255, 255)'].map(rgb => RGBColor.fromCSS(rgb));
exports.DEFAULT_COLORS = DEFAULT_COLORS;